import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function SmileViewSection() {
  return <section className="py-24 bg-weiss relative overflow-hidden" data-id="element-183">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-beige/30 rounded-[3rem] p-12 md:p-20 border border-sand/50" data-id="element-185">
          <motion.div animate={{
          rotate: [0, 10, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block mb-6" data-id="element-186">
            <SparklesIcon className="w-12 h-12 text-royal-blue" data-id="element-187" />
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-heading text-schwarz mb-6" data-id="element-188">
            Traumlächeln auf Knopfdruck
          </h2>

          <p className="text-lg text-warm-gray mb-10 max-w-2xl mx-auto leading-relaxed font-body" data-id="element-189">
            Sind Sie unzufrieden mit Ihrem Zahnstand und hätten Sie gerne ein
            neues und aussagekräftigeres Lächeln? Dann scannen Sie den Code oder
            benutzen Sie unseren Link und machen ein Selfie, um Ihr SmileView
            Abenteuer zu beginnen.
          </p>

          <motion.button whileHover={{
          scale: 1.05,
          y: -2
        }} whileTap={{
          scale: 0.95
        }} className="bg-royal-blue text-weiss px-8 py-4 rounded-full text-lg font-heading shadow-lg shadow-royal-blue/30 transition-all hover:shadow-xl hover:shadow-gold/20 border border-transparent hover:border-gold" data-id="element-190">
            Jetzt ausprobieren
          </motion.button>
        </motion.div>
      </div>
    </section>;
}